<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'labels'],
  mounted () {
    this.render()
  },
  computed: {
    chartData () {
      return this.values
    }
  },
  watch: {
    values () {
      this.$data._chart.destroy()
      this.render()
    }
  },
  methods: {
    render () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Quantidade de pessoas',
            backgroundColor: '#2d579b',
            data: this.chartData
          }
        ]
      },
      { responsive: true, maintainAspectRatio: true })
    }
  },
}
</script>
